// extracted by mini-css-extract-plugin
export default {"ProjectCardMain":"ProjectCard_ProjectCardMain__21olA","projectPreview":"ProjectCard_projectPreview__dYiT5","tags":"ProjectCard_tags__w4WEs","links":"ProjectCard_links__hdiYE"};